import React from 'react';
import { RouteObject } from 'react-router-dom';
import {
    BillingProvider,
    DocumentPreviewOverlay,
    DocumentPreviewProvider,
    DossierPrescriberProvider,
    SelectedOrderProvider,
} from '@europrocurement/l2d-modules';
import {
    ordersBasePath,
    orderDetailPath,
    listeordersPath,
    ordersFacturationPath,
} from './constants';
import { OrderRoot, OrderDetail, OrderDuplicate, ListeOrders } from './views';
import { FacturationTab } from '../Dossiers/components';

export const OrderRouter: RouteObject = {
    path: ordersBasePath,
    element: <OrderRoot />,
    children: [
        {
            path: listeordersPath,
            index: true,
            element: <ListeOrders />,
        },
        {
            path: orderDetailPath,
            element: (
                <SelectedOrderProvider>
                    <OrderDetail />
                </SelectedOrderProvider>
            ),
        },
        {
            path: `${orderDetailPath}/duplication`,
            element: (
                <SelectedOrderProvider>
                    <OrderDuplicate />
                </SelectedOrderProvider>
            ),
        },
        {
            path: ordersFacturationPath,
            element: (
                <BillingProvider origine="B2D">
                    <DocumentPreviewProvider>
                        <DossierPrescriberProvider>
                            <FacturationTab />
                            <DocumentPreviewOverlay />
                        </DossierPrescriberProvider>
                    </DocumentPreviewProvider>
                </BillingProvider>
            ),
        },
    ],
};
